import React from 'react'

import * as ArticleComponents from 'components/ArticleComponents'

import TestCardsTable from '../TestCardsTable'


const Test3DSCardsSection = () => {
	return (
		<>
			<ArticleComponents.P>
				For testing 3DS, you can use the following test cards to simulate scenarios:
			</ArticleComponents.P>

			<TestCardsTable getCards={data => data.cards.threeDSecure.filter((card => !!card.scenario) && (card => !!card.platform))} />
		</>
	)
}

export default Test3DSCardsSection
 